export default "__VITE_ASSET__BExKywsY__"